import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.url = this.el.dataset.url;
        this.el.addEventListener('change', this.onChange.bind(this));

        this.el.querySelector('input[name="reset"]').addEventListener('click', this.reset.bind(this));
    }

    onChange(e) {
        this.fetchData();
    }

    reset(e) {

        this.el.querySelector('#capacite').value = 5;
        //console.log(this.el.querySelector('#capacite'))
        this.el.querySelectorAll('input[name="table"]').forEach((el) => {
            el.checked = false;
        });

        this.el.querySelectorAll('input[name="particularite[]"]').forEach((el) => {
            el.checked = false;
        });
        this.el.querySelectorAll('input[name="configuration[]"]').forEach((el) => {
            el.checked = false;
        });


        setTimeout(() => {
            this.fetchData();
        }, 200);
    }

    fetchData() {
        // add class on html
        document.body.parentElement.classList.add('page-is-loading');
        if (this.controller) {
            this.controller.abort();
        }
        this.controller = new AbortController();
        fetch(this.url + '?' + new URLSearchParams(new FormData(this.el)), {
            signal: this.controller.signal
        })
            .then(response => response.text())
            .then(html => {
                let parser = new DOMParser();
                let doc = parser.parseFromString(html, 'text/html');
                document.getElementById('salles-list').innerHTML = doc.getElementById('salles-list').innerHTML;
                document.body.parentElement.classList.remove('page-is-loading');

                // swap pager .c-pager with new one if exists
                let pager = doc.querySelector('.c-pager');
                if (pager) {
                    document.querySelector('.c-pager').innerHTML = pager.innerHTML;
                } else {
                    document.querySelector('.c-pager').innerHTML = '';
                }

                // update current url
                window.history.pushState({}, '', this.url + '?' + new URLSearchParams(new FormData(this.el)));
            })
            .catch(err => {
                document.body.parentElement.classList.remove('page-is-loading');
                //console.log(err);
            });
    }
}
